<div *ngIf="obtainingPermissions && !errorObtainingPermissions" style="align-content:center;">
  <h1 style="margin: 25px; text-align:center; "><mat-spinner style="margin:0 auto" diameter="30"></mat-spinner>Logging In</h1>
</div>
<div *ngIf="errorObtainingPermissions" style="align-content:center;">
  <h1 style="margin: 25px; text-align:center; ">You are not authorized to access this application.Please contact your Administrator for assistance.</h1>
</div>
<div style="background-image: linear-gradient(to right, #48c3c1, #97dada, #c2dddf)" *ngIf="!obtainingPermissions && !errorObtainingPermissions">
  <div class="grid-home">
    <div class="grid-item-home">
      <div style="margin: 25px; padding: 10px; color: #f3f3f3; display: inline-block">
        <h3 style="font-size:34px; font-weight:500;">Welcome back<span *ngIf="!isAuthenticated">!</span><span *ngIf="isAuthenticated">,</span></h3>
        <h3 style="font-size: 34px; font-weight: 500;" *ngIf="isAuthenticated">{{name}}</h3>
        <h3 *ngIf="!isAuthenticated">Please log in</h3>
        <h5>{{now | date:'EEEE, MMMM d, y h:mm a'}}</h5>
      </div>
    </div>
    <div class="grid-item-home">
      <div style="display: inline-block">
        <app-dashboard *ngIf="isAuthenticated"></app-dashboard>
      </div>
    </div>
  </div>
</div>
